import { Link } from 'react-router-dom';

import type { AISettings, McpGrant } from '@/store/api/mcpMemberApi';
import type { FC } from 'react';

interface ConnectionStatusProps {
  grants: McpGrant[] | undefined;
  settings: AISettings | undefined;
}

const ConnectionStatus: FC<ConnectionStatusProps> = ({ grants, settings }) => {
  const grant = grants?.[0];
  if (grant) {
    const parts = ['coaching notes'];
    if (settings?.reflections_enabled) parts.push('reflections');
    if (settings?.transcripts_enabled) parts.push('transcript search');
    return (
      <div className="mb-8 flex items-center gap-3 rounded-2xl bg-white px-4 py-3.5 text-[15px] shadow">
        <span aria-hidden="true" className="size-2 rounded-full bg-sage-500" />
        <div className="min-w-0 flex-1">
          <b>Shared with {grant.client_name}</b> · {parts.join(', ')}
        </div>
        <Link className="text-sage-500" to="/m/settings/connect-ai">
          Manage
        </Link>
      </div>
    );
  }
  return (
    <div className="mb-8 flex items-center gap-3 rounded-2xl border border-solid border-cement-200 px-4 py-3.5 text-[15px]">
      <span aria-hidden="true" className="size-2 rounded-full bg-cement-300" />
      <div className="min-w-0 flex-1">Not shared with any AI yet.</div>
      <Link className="text-sage-500" to="/m/settings/connect-ai">
        Connect your AI
      </Link>
    </div>
  );
};

export default ConnectionStatus;
